import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  client: null
};

const activeClientSlice = createSlice({
  name: "activeClient",
  initialState,
  reducers: {
    setActiveClient(state, action) {
      state.client = action.payload || null;
    },
    clearActiveClient(state) {
      state.client = null;
    }
  }
});

export const { setActiveClient, clearActiveClient } = activeClientSlice.actions;
export default activeClientSlice.reducer;
